const toHex = (color) => {
    return (color + 0x1000000).toString(16).substring(1);
};

export default toHex;
